<template>
<div class="succes-banner" >
<div class="banner-content">
  <h2>{{$t('success-notice.success')}}</h2>
	<div class="checkmark-wrapper" >
     <svg class="check-svg" width="200" height="120" xmlns="http://www.w3.org/2000/svg">
        <path  class="checkmark" d="M 10 10 10 90 200 90 " fill="transparent" stroke="var(--flame)" stroke-width="14px"   stroke-linecap="round"  stroke-linejoin="round"/>
      </svg>
	</div>
  </div>
</div>
</template>

<script>

export default {
  props: {
   succes: Boolean,  
  }
}
</script>

<style lang="less">
  .succes-banner{
    position: absolute;
    top:0;
    right: 4%;
    width: 140px;
    height: 40px;
    animation: succes 4s ease;
    background-color: #fff;
    box-shadow: 2px 0 4px 0 rgba(0, 0, 0, 0.25);
    z-index: 999;
     
     .banner-content{
       position: relative;
     }
    h2 {
    font-size: 18px;
    color: #3D464A;
    margin: 10px !important;
    display: flex;
    justify-content: left;
    align-items: center;
  }
  p {
    margin: 10px auto 15px; 
  }
.checkmark-wrapper{
        position: absolute;
    top: -53px;
    right: -70px;
    margin: 0 auto;
    transform-origin: center;
}
 .check-svg{
      
        transform:rotate(-45deg) scale(0.13);
  }   

.checkmark {
  stroke-dasharray: 260;
  stroke-dashoffset: 0;
  animation: dash 1s reverse;
  animation-delay: .5s;
  transform-origin: center;
}
@keyframes dash {
  from{
      opacity: 1;
  }
  to {
      opacity: 0;
    stroke-dashoffset: 250;
  }
}
@keyframes succes {
0%{ transform: translateY(-200px);}
  30% {
      transform: translateY(0px)
  }

  70% {
      transform: translateY(0px)
  }
  90% {
      transform: translateY(-200px)
  }


100%{
    transform: translateY(-200px);
  }
}
  }

</style>
